var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',[_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex","justify":"end"}},[_c('el-col',{attrs:{"xs":24,"sm":24,"md":10,"lg":10,"xl":10}},[_c('p',[_vm._v("Developed by "),_c('img',{attrs:{"src":require("@/assets/img/cryptomarket-blanc.png")}})])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca427cd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/merchants/Footer.vue
// module id = null
// module chunks = 